import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { apiGenerator } from 'utils/apiHelpers';
import { setAccessTokenInLocalStorage } from 'helpers/storage.helpers';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const getUser = () => {
    apiGenerator('get')('/users/me')
      .then((res) => {
        setUser(res.data);
      })
      .catch((err) => {
        navigate('/login', { replace: true });
      });
  };

  const login = async (data) => {
    const body = {
      ...data,
      client_id: 'w7IU2m3j9w-eiVRlJEj929P6TKSup5ba7YsbOsvofIc',
      client_secret: '6mOmBvCbreOKxC_FCosW_AAm8EVd1_Kjn5uSUq6Zs-s',
      grant_type: 'password',
    };
    apiGenerator('post')('/oauth/token', body)
      .then((res) => {
        setAccessTokenInLocalStorage(res.data.access_token);
        getUser();
      })
      .catch((err) => {
        console.log(err);
      });

    // navigate('/dashboard/profile', { replace: true });
  };

  const logout = () => {
    setUser(null);
    setAccessTokenInLocalStorage(null);
    navigate('/login', { replace: true });
  };

  return <AuthContext.Provider value={{ user, login, logout, getUser }}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export const useAuth = () => useContext(AuthContext);
